import React from 'react';
import { Box } from '@mui/material';
import { useWebLocale } from '../../../../contexts/WebLocaleContext';
import './AlbumNote.css';

export default function AlbumNote({ comment, sx }) {
  const { locale } = useWebLocale();
  if (!comment) return null;
  return (
    <Box
      component="section"
      className="pp-album-note"
      sx={sx}
      aria-label={locale === 'en' ? 'Album note' : '앨범 노트'}
    >
      <h2>{locale === 'en' ? 'Album note' : '앨범 노트'}</h2>
      <div className="pp-album-note-body">
        <svg width="11" height="11" viewBox="0 0 14 14" aria-hidden="true">
          <path
            fill="currentColor"
            d="M0 7.1C0 3.7 1.7 1.3 5 0l.8 1.8C4 2.6 3.1 3.8 2.9 5.2h2.8V10H0V7.1Zm8.2 0c0-3.4 1.7-5.8 5-7.1l.8 1.8c-1.8.8-2.7 2-2.9 3.4H14V10H8.2V7.1Z"
          />
        </svg>
        <p>{comment}</p>
      </div>
    </Box>
  );
}
